import { Meter as RACMeter, ProgressBar as RACProgressBar } from "react-aria-components";
import { cx } from "../tv";

/** Thin meter. Turns Ember at or above `warnAt` (budgets, retainers, capacity). */
export function Meter({ value, label, warnAt = 85, width = 88, className, tone = "accent" }: {
  value: number; label: string; warnAt?: number; width?: number; className?: string; tone?: "accent" | "hue";
}) {
  return (
    <RACMeter value={value} aria-label={label} className={cx("inline-flex items-center", className)}>
      {({ percentage }) => (
        <span className="block h-[5px] overflow-hidden rounded-pill bg-border" style={{ width }}>
          <span
            className={cx("block h-full rounded-pill transition-[width] duration-(--dur-base)", percentage >= warnAt ? "bg-[var(--code-ember-solid)]" : tone === "hue" ? "bg-hue" : "bg-accent")}
            style={{ width: `${Math.min(100, percentage)}%` }}
          />
        </span>
      )}
    </RACMeter>
  );
}

export function ProgressBar({ value, label, className }: { value: number; label: string; className?: string }) {
  return (
    <RACProgressBar value={value} aria-label={label} className={cx("block w-full", className)}>
      {({ percentage }) => (
        <span className="block h-[5px] w-full overflow-hidden rounded-pill bg-border">
          <span className="block h-full rounded-pill bg-accent transition-[width] duration-(--dur-base)" style={{ width: `${percentage}%` }} />
        </span>
      )}
    </RACProgressBar>
  );
}

/** Ring progress ("Donut", never ".ring": Tailwind owns that name). */
export function Donut({ value, size = 44, stroke = 5, label }: { value: number; size?: number; stroke?: number; label: string }) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  return (
    <svg width={size} height={size} role="img" aria-label={label}>
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="var(--border)" strokeWidth={stroke} />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={r}
        fill="none"
        stroke="var(--accent)"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeDasharray={`${(Math.min(100, value) / 100) * c} ${c}`}
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
      />
    </svg>
  );
}
